import {createContext} from 'react';

const PaymentContext = createContext(null);

export default PaymentContext;
